module.exports = __webpack_public_path__ + "img/wait.04abb2c9.png";